import { render } from "./productAmount.vue?vue&type=template&id=08202713&scoped=true"
import script from "./productAmount.vue?vue&type=script&lang=js"
export * from "./productAmount.vue?vue&type=script&lang=js"

import "./productAmount.vue?vue&type=style&index=0&id=08202713&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08202713"]])

export default __exports__